export const Header = (props) => {
  const rating = props.contact?.rating || '4.5';
  const reviewCount = props.contact?.reviewCount || '105';
  const stats = [
    { value: '20+', label: 'Years in Operation' },
    { value: `${rating}★`, label: 'Google Rating' },
    { value: '4hrs', label: 'Emergency Response' },
    { value: `${reviewCount}+`, label: 'Client Reviews' },
  ];

  return (
    <header id='header'>
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.45) 100%), url(img/intro-bg.jpeg) center center / cover no-repeat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: '70px',
      }}>

        {/* Hero Content */}
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 24px 40px',
        }}>
          <div style={{ textAlign: 'center', maxWidth: '800px' }}>

            {/* Location Badge */}
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: 'rgba(92, 169, 251, 0.2)',
              border: '1px solid rgba(92, 169, 251, 0.5)',
              borderRadius: '25px',
              padding: '6px 18px',
              marginBottom: '28px',
            }}>
              <i className='fa fa-map-marker' style={{ color: '#5ca9fb', fontSize: '13px' }}></i>
              <span style={{ color: '#5ca9fb', fontSize: '13px', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
                Serving Lagos & Nationwide · Available 24/7
              </span>
            </div>

            {/* Main Title */}
            <h1 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(36px, 6vw, 72px)',
              fontWeight: '800',
              color: '#fff',
              lineHeight: '1.1',
              margin: '0 0 20px',
              textTransform: 'uppercase',
              letterSpacing: '-1px',
            }}>
              {props.data ? props.data.title : 'Reliable Commercial HVAC Solutions'}
            </h1>

            {/* Subtitle */}
            <p style={{
              color: 'rgba(255,255,255,0.85)',
              fontSize: 'clamp(16px, 2.5vw, 20px)',
              fontWeight: '300',
              lineHeight: '1.7',
              margin: '0 auto 40px',
              maxWidth: '580px',
            }}>
              {props.data ? props.data.paragraph : 'Commercial HVAC & energy-efficient cooling for businesses across Lagos.'}
            </p>

            {/* CTA Buttons */}
            <div style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}>
              <a
                href='https://wa.me/2348103218560?text=Hello%20Ac-Tech!%20I%E2%80%99d%20like%20to%20get%20a%20quote%20for%20AC%20service.%20Can%20you%20help%3F'
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'linear-gradient(to right, #25D366, #128C7E)',
                  color: '#fff',
                  padding: '16px 36px',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  fontWeight: '700',
                  fontSize: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: '0 8px 25px rgba(37,211,102,0.45)',
                }}
              >
                <i className='fa fa-whatsapp'></i>
                Request a Quote
              </a>
              <a
                href='tel:08103218560'
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'transparent',
                  color: '#fff',
                  padding: '16px 36px',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  fontWeight: '700',
                  fontSize: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  border: '2px solid rgba(255,255,255,0.6)',
                }}
              >
                <i className='fa fa-phone'></i>
                Call Now
              </a>
            </div>

          </div>
        </div>

        {/* Stats Bar */}
        <div style={{
          background: 'rgba(0,0,0,0.55)',
          backdropFilter: 'blur(10px)',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          padding: '24px',
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px',
            textAlign: 'center',
          }} className='stats-grid'>
            {stats.map((stat, i) => (
              <div key={i} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                padding: '0 8px',
              }}>
                <span style={{
                  color: '#5ca9fb',
                  fontSize: 'clamp(22px, 3vw, 30px)',
                  fontWeight: '800',
                  fontFamily: 'Raleway, sans-serif',
                  lineHeight: 1,
                }}>
                  {stat.value}
                </span>
                <span style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  fontWeight: '500',
                }}>
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>

      <style>{`
        @media (max-width: 600px) {
          .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
      `}</style>
    </header>
  );
};
